import React from 'react'
import logo from '../logo-text.png'

const Terms = () => (
    <>
    <div className="level-item">
        <img src={logo} alt="Logo" style={{width: 400, height: 400, marginBottom: '-2.5%'}}/>
    </div>  <h1 className="is-size-1">Thank you for using Clusterfy</h1>
    <h2 className="is-size-2">These terms and conditions outline the services we provide to you. When you create a Clusterfy account, or use any of our services, these terms will apply.
    </h2>
    <h2 className="is-size-3">Accepting Terms and Conditions
    </h2>
    <p className="is-size-4">
        In order to use our website you must first agree to the terms and conditions. You will not be able to use the website if you do not agree to use the site.
    </p>
    <p className="is-size-4">
        Whenever you use our website, you agree to these terms and conditions
    </p>
    <p className="is-size-4">
        If you are not of legal age to use the website, you cannot use the website
    </p>
    <h2 className="is-size-3">Who can use Clusterfy</h2>
    <p className="is-size-4">
        You have to be at least 13 years of age
    </p>
    <p className="is-size-">Cannot be a convicted sex offender
    </p>
    <h2 className="is-size-3">Expectations from member</h2>
    <p className="is-size-4">
        You must not post nudity
    </p>
    <p className="is-size-4">
        You cannot make any threats harming others
    </p>
    <p className="is-size-4">
        You cannot upload malicious computer viruses
    </p>
    <h2 className="is-size-3">Deletion of Account and Content</h2>
    <p className="is-size-4">
        When agreeing to the terms and conditions, you become aware that Clusterfy has the right to delete your account at any moment along with content that violates the community guidelines, without any response from the user prior to deletion.
    </p>
    <h2 className="is-size-3">
        Jurisdiction
    </h2>
    <p className="is-size-4">
        Any claims about these terms and conditions will be governed by New Jersey law.
    </p>
    <h2 className="is-size-3">Liabillity</h2>
    <p className="is-size-4">
        There is no guarantee that our website will be error free, secure, safe. We cannot control what other people say and what they upload to our website and are not responsible for their actions on or off of the website. In addition, we are not responsible for content users share such as anything harmful, threatening, offensive, or illegal.
    </p>
    <p className="is-size-4">
        We cannot predict any issues that come about with our website. Under no circumstance should we be accountable for loss of any profit, data, or incidental damages. Our liability will not go over $10 for any losses you have made with real money.

    </p>
    <p className="is-size-4">
        We do not provide any advice on how to invest in the stock market, In addition, the currency used on the site is a fake digital currency that holds no value in the real world. By no means is this website responsible to replicate the stock market exactly, we try our best to make it easy for users to understand how the stock market works.

    </p>
    <h2 className="is-size-3">Copyright</h2>
    <p className="is-size-4">
        By using our site you are agreeing to not use the name Clusterfy whether it is the following: domain name, logo, and distinctive features.

    </p>
    <h2 className="is-size-3">External Links</h2>
    <p className="is-size-4">
        In the event if you click on an external link, we will not be liable for any actions you take on that site as you have left our site. Your use of these external links are not to our fault and you must use them at your own risk. 

    </p>
    <h2 className="is-size-3">Advertisements</h2>
    <p className="is-size-4">
        Though we may not sell your information to advertisers you do agree that Clusterfy will be allowed to have advertisements in the future for the website. 
    </p>
    </>
)

export default Terms